import React from 'react'
import { useInternationalization } from '../features/i18n'
import { ButtonOutline } from './buttons'

const FileUploader = ({inputTrigger, onChange}) => {
  const fileInput = React.useRef()
  const { translate } = useInternationalization()

  return (
    <>
      <input type="file" className="hide hidden" onChange={onChange} ref={fileInput}/>

      <div
        className="border border-dashed rounded p-6 flex items-center justify-center cursor-pointer"
        style={{borderColor: '#ddd'}}
        onClick={() => fileInput.current.click()}
      >
        {
          inputTrigger !== 'button' &&
          <p className="text-gray-999 underline text-sm">{translate('GENERAL', 'choose_file')}</p>
        }
        {
          inputTrigger === 'button' &&
          <ButtonOutline style={{maxWidth: '160px'}}>{translate('GENERAL', 'choose_file')}</ButtonOutline>
        }
      </div>
    </>
  )
}

export { FileUploader }
